
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mi",
      function () {
        return require("private-next-pages/mi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mi"])
      });
    }
  